import { Environment } from '@gmg/gmg-react-components';
import { ResourcesConfig } from 'aws-amplify';

export interface FeatureFlags {
    showPartnerPortal: boolean;
    showDataAndAccessManagement: boolean;
    showSiteAssignment: boolean;
    showSitesPage: boolean;
    hideOptimize: boolean;
    hideColorCardUsage: boolean;
    usePartnerPortalDedicatedCognitoClient?: boolean;
}
export interface IConfig {
    amplify: ResourcesConfig;
    featureFlags: FeatureFlags;
    partnerPortalBaseUrl: string;
    partnerPortalIdentityProviderName: string;
    partnerPortalUserPoolWebClientId?: string;
    entraLogoutUrl?: string;
    trackJs: {
        token: string;
        application: string;
    };
    tracking: {
        domain: string;
        enabled: boolean;
        ignore: Array<string>;
    };
    modules: Array<string>;
    env: Environment;
}

export const getConfig = (json: any): IConfig => ({
    amplify: {
        Auth: {
            Cognito: {
                userPoolId: json.AMPLIFY_AUTH_USERPOOLID!,
                userPoolClientId: json.AMPLIFY_AUTH_USERPOOLWEBCLIENTID!,
                loginWith: {
                    oauth: {
                        domain: json.AMPLIFY_OAUTH.DOMAIN,
                        scopes: json.AMPLIFY_OAUTH.SCOPE,
                        redirectSignIn: [json.AMPLIFY_OAUTH.REDIRECTSIGNIN],
                        redirectSignOut: [json.AMPLIFY_OAUTH.REDIRECTSIGNOUT],
                        responseType: json.AMPLIFY_OAUTH.RESPONSETYPE, // or 'token', note that REFRESH token will only be generated when the responseType is code
                    },
                },
            },
        },
        API: {
            GraphQL: {
                endpoint: json.APPSYNCH_GRAPHQLENDPOINT!,
                defaultAuthMode: json.APPSYNCH_AUTHENTICATIONTYPE!,
            },
        },
    },
    featureFlags: {
        showPartnerPortal: !!json.FEATURE_FLAGS.SHOW_PARTNER_PORTAL,
        showDataAndAccessManagement: json.FEATURE_FLAGS.SHOW_DATA_AND_ACCESS_MANAGEMENT,
        showSiteAssignment: !!json.FEATURE_FLAGS.SHOW_SITE_ASSIGNMENT,
        showSitesPage: !!json.FEATURE_FLAGS.SHOW_SITES_PAGE,
        hideOptimize: json.FEATURE_FLAGS.HIDE_OPTIMIZE_MODULE,
        hideColorCardUsage: json.FEATURE_FLAGS.HIDE_COLORCARD_USAGE,
        usePartnerPortalDedicatedCognitoClient: !!json.FEATURE_FLAGS.USE_PARTNER_PORTAL_DEDICATED_COGNITO_CLIENT,
    },
    partnerPortalBaseUrl: json.PARTNER_PORTAL_BASE_URL || '',
    partnerPortalIdentityProviderName: json.PARTNER_PORTAL_IDENTITY_PROVIDER_NAME || '',
    partnerPortalUserPoolWebClientId: json.PARTNER_PORTAL_USERPOOLWEBCLIENTID || undefined,
    entraLogoutUrl: json.ENTRA_LOGOUT_URL || undefined,
    trackJs: json.TRACKJS!,
    tracking: {
        domain: json.TRACKING.DOMAIN,
        enabled: json.TRACKING.ENABLED,
        ignore: json.TRACKING.IGNORE,
    },
    modules: [
        'Optimize',
        'ColorProofGO',
        'ColorCard',
        'PhotoshopPluginBasic',
        'PhotoshopPluginPackaging',
        'PhotoshopPluginINTERNAL',
        'VectorPlugin',
        'Measure',
    ],
    env: json.ENVIRONMENT,
});
